import React, { useEffect, useState } from 'react';

const ElencoCondomini = () => {
  const [condomini, setCondomini] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/external/condominio', {
      headers: {
        'x-api-version': '1.0',
        'X-DANEA-API-KEY': 'aa29bb1e-f99a-473b-9bae-8ba333afc1b9',
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Errore nella richiesta API');
        }
        return res.json();
      })
      .then((data) => {
        setCondomini(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Caricamento...</p>;
  }

  if (error) {
    return <p>Errore: {error}</p>;
  }

  return (
    <div>
      <h2>Elenco condomini</h2>
      {condomini.length === 0 ? (
        <p>Nessun condominio trovato.</p>
      ) : (
        condomini.map((condo) => (
          <div key={condo.id} style={{ border: '1px solid #ccc', margin: '10px', padding: '10px' }}>
            <h3>{condo.intestazione}</h3>
            <p>Indirizzo: {condo.indirizzo}, {condo.cap} {condo.citta} ({condo.prov})</p>
            <h4>Amministratore</h4>
            <p>Nome: {condo.amministratore.nome}</p>
            <p>Indirizzo: {condo.amministratore.indirizzo}, {condo.amministratore.cap} {condo.amministratore.citta}</p>
            <p>Telefono: {condo.amministratore.tel}</p>
            <p>Email: {condo.amministratore.email}</p>
          </div>
        ))
      )}
    </div>
  );
};

export default ElencoCondomini;
